export const environment = {
	production: true,
  	apiUrl: 'http://portal.esourcing.io/api'
};
